import { FormField } from '@monoimin/sb-types';

import { FieldConfig, FormConfig } from '../types';

const SURVEY_CHOICE_POINTS = [4, 3, 2, 1];

const isSurveyAnswerKey = (item: string): boolean =>
  typeof item === 'string' &&
  item.startsWith('answer_') &&
  item.includes('_customer_survey');

export const processCustomerSurveyAnswers = (
  entries: [string, FormDataEntryValue][],
  formConfig: FormConfig
): [string, FormDataEntryValue][] => {
  const answerFields = entries.filter(([key]) => isSurveyAnswerKey(key));

  const updatedAnswerFields: [string, FormDataEntryValue][] = answerFields.map(
    ([key, value]) => {
      // 'ustomer_survey' - это не опечатка, так и задумано
      const updatedKey = key.replace('ustomer_survey', '');
      const capitalizedKey =
        typeof updatedKey === 'string'
          ? updatedKey.charAt(0).toUpperCase() + updatedKey.slice(1)
          : '';
      return [capitalizedKey, value];
    }
  );

  const questionFields: [string, FormDataEntryValue][] = answerFields.map(
    ([key], index) => [
      `Question_${index + 1}__c`,
      formConfig.fields.find((el) => el.adminLabel === key)?.label || '',
    ]
  );

  const pointFields: [string, FormDataEntryValue][] = answerFields.map(
    ([key, value], index) => {
      const field = formConfig.fields.find(
        (el: FormField | FieldConfig) =>
          el.adminLabel === key && Array.isArray(el.choices)
      );
      const choices = field?.choices;

      const updatedChoices = Array.isArray(choices)
        ? choices.map((choice, choiceIndex) => ({
            ...choice,
            point: SURVEY_CHOICE_POINTS[choiceIndex] ?? null,
          }))
        : undefined;

      const choicePoint = Array.isArray(updatedChoices)
        ? updatedChoices.find((choice) => choice.text === value)?.point ?? -1
        : -1;

      return [`Points_${index + 1}__c`, choicePoint.toString()];
    }
  );

  const filteredEntries = entries.filter(([key]) => !isSurveyAnswerKey(key));

  return [
    ...filteredEntries,
    ...updatedAnswerFields,
    ...questionFields,
    ...pointFields,
  ];
};
